import { useNavigate } from "react-router-dom";
import Button from "../../../ui/Button";
import style from "./PurposeCtaArea.module.scss";

type Prop = {
    heading?: string;
    paragraph?: string;
    button?: string;
    path?: string;
};

//!! ============== PURPOSE CTA SECTION COMPONENT ?? //
export function PurposeCtaArea({ button, heading, paragraph, path }: Prop) {
    const navigate = useNavigate();
    return (
        <div className={style.PurposeCtaArea}>
            <div className="wrapper-constrain">
                <div className="">
                    <h2>
                        {heading
                            ? heading
                            : "We are committed to your safety, ease, and comfort"}
                    </h2>
                </div>
                <div className="">
                    <p>
                        {paragraph
                            ? paragraph
                            : "Our thorough verification process ensures that every user is trustworthy and dependable. From background checks to ride reviews, we've got your safety and comfort covered at every step."}
                    </p>
                    <Button
                        onClick={() => navigate(`${path || "/safety"}`)}
                        variant="secondary"
                        content={`${button ? button : "Learn More >"}`}
                    ></Button>
                </div>
            </div>
        </div>
    );
}
